<template>
  <report-form
    v-model="payload"
    :page-title="$t('app.reports.comissoes.title')"
    :request-class="requestClass"
    :total-group="1"
    navigate-back-route="Reports"
    navigate-page-after-save="Reports"
  >
    <template slot="group-1">
      <form-group :title="$t('app.reports.subtitle')">
        <v-flex
          xs12
          lg6
        >
          <input-text
            id="prorrogacaoNumberField"
            v-model="payload.prorrogacaoNumber"
            mask="##########"
            return-masked-value
            :label="$t('support.components.reports.prorrogacaoNumber')"
          />
          <input-autocomplete
            v-model="payload.retentor"
            input-key="retentorField"
            item-text="text"
            item-value="value"
            :items="retentorItens"
            return-object
            :label="$t('app.reports.comissoes.form.retentor.field')"
          />
          <date-interval
            v-model="payload.contratacao"
            input-key="dateIntervalContratacao"
            identifier="contratacao"
            :label="$t('app.reports.comissoes.form.contratacaoDate')"
          />
          <date-interval
            v-model="payload.vencimento"
            input-key="dateIntervalVencimento"
            identifier="vencimento"
            :label="$t('app.reports.comissoes.form.vencimentoDate')"
          />
          <date-interval
            v-model="payload.baixa"
            input-key="dateIntervalBaixa"
            identifier="baixa"
            :label="$t('app.reports.comissoes.form.baixaDate')"
          />
          <money-interval
            v-model="payload.money"
            input-key="moneyInterval"
            identifier="money"
          />
          <formats-autocomplete
            v-model="payload.format"
          />
        </v-flex>
      </form-group>
    </template>
  </report-form>
</template>

<script>
import DateInterval from 'Support/components/reports/DateInterval.vue';
import MoneyInterval from 'Support/components/reports/MoneyInterval.vue';
import FormGroup from 'Support/layout/FormGroup.vue';
import ComissoesRequest from 'Domain/reports/ComissoesRequest';
import ReportForm from 'Support/components/reports/ReportForm.vue';
import RulesMixin from 'Support/mixins/rules-mixin';
import ReportMixin from 'Support/mixins/ReportMixin';
import InputText from 'Support/components/inputs/InputText.vue';
import FormatsAutocomplete from 'Support/components/reports/FormatsAutocomplete.vue';
import InputAutocomplete from 'Support/components/inputs/InputAutocomplete.vue';

export default {
  name: 'ComissoesReport',
  components: {
    ReportForm,
    FormGroup,
    MoneyInterval,
    DateInterval,
    FormatsAutocomplete,
    InputText,
    InputAutocomplete,
  },
  mixins: [RulesMixin, ReportMixin],
  data: () => ({
    requestClass: ComissoesRequest,
    payload: {
      prorrogacaoNumber: '',
      retentor: '',
      contratacao: {
        dataInicial: '',
        dataFinal: '',
      },
      vencimento: {
        dataInicial: '',
        dataFinal: '',
      },
      baixa: {
        dataInicial: '',
        dataFinal: '',
      },
      money: {
        initialValue: '',
        finalValue: '',
      },
      format: 'PDF',
    },
  }),
  computed: {
    retentorItens() {
      return [
        {
          text: this.$t('app.reports.comissoes.form.retentor.values.grupoCard'),
          value: 'GRUPOCARD',
        },
        {
          text: this.$t('app.reports.comissoes.form.retentor.values.tecfin'),
          value: 'TECFIN',
        },
        {
          text: this.$t('app.reports.both'),
          value: 'AMBOS',
        },
      ];
    },
  },
};
</script>
